export enum NotificationTypes {
  Owner = 1,
  Subscriber = 2,
  Global = 3,
  Mention = 4,
}
